import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const textVariant = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.6 },
  }),
};

const NotFound = () => {
  const messages = [
    "Oops!",
    "404 - Page Not Found",
    "We can't find what you're looking for.",
    "But don't worry, let’s get you back home.",
  ];

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | UrbanCasa</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <Container maxWidth="md">
        <Box
          textAlign="center"
          mt={12}
          component={motion.div}
          initial="hidden"
          animate="visible"
        >
          {messages.map((msg, index) => (
            <motion.div key={index} custom={index} variants={textVariant}>
              <Typography
                variant={index === 1 ? "h3" : "h6"}
                color={index === 1 ? "error" : "textSecondary"}
                gutterBottom
                sx={{ mb: 2 }}
              >
                {msg}
              </Typography>
            </motion.div>
          ))}

          <motion.div custom={messages.length} variants={textVariant}>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/"
              sx={{ mt: 4 }}
            >
              Go to Home
            </Button>
          </motion.div>
        </Box>
      </Container>
    </>
  );
};

export default NotFound;
